const pushToGa4 = (eventName, eventOption1, eventOption2, eventOption4) => {
    window.dataLayer.push({
        event: "ga4genericEvent",
        event_name: eventName,
        event_option1: eventOption1,
        event_option2: eventOption2,
        event_option4: eventOption4
    });
}

export { pushToGa4 };
